import { FC, ReactNode } from 'react';
import { getDisplayedMax, MaxAmount } from '../../../hooks/useMaxTokenAmount';
import { asDecimal } from '@silo/utils';
import { Button } from '@silo/ui';

interface MaxAmountInputProps {
  max: MaxAmount;
  doMax: () => void;
  maxLabelSlot: ReactNode;
  maxButtonContentSlot?: ReactNode;
  symbol?: string;
  disabled?: boolean;
}

export const MaxAmountInput: FC<MaxAmountInputProps> = ({
  maxLabelSlot,
  max,
  doMax,
  symbol,
  disabled,
  maxButtonContentSlot,
}) => {
  const displayedMax = getDisplayedMax(max);

  return (
    <div>
      <div className="flex flex-col gap-2.5 sm:flex-row sm:justify-between items-start sm:items-center">
        <span className="text-base text-shale-200">{maxLabelSlot}</span>
        <div className="flex items-center gap-5">
          <span
            className={`font-mono text-base font-medium ${disabled ? 'text-slate-400' : 'text-white'}`}
            data-cy="max-amount"
          >
            {asDecimal(displayedMax)} {symbol}
          </span>
          <Button variant="action" onClick={doMax} data-cy="max-button" disabled={disabled} size="small">
            {maxButtonContentSlot ?? 'Max'}
          </Button>
        </div>
      </div>
    </div>
  );
};
